export default {
  ACTIVESTEP: 'SIGNUP_ACTIVESTEP',
  USER_CREATED: 'SIGNUP_USER_CREATED'
};
